/**
 * Live updates over `GET /api/live` (WebSocket). Events are invalidation hints only: they never
 * carry ticket content. Clients refetch through the normal permission-checked API.
 */
import { z } from 'zod'

export const LIVE_PATH = '/api/live'
/** Client → server keep-alive (the server answers `pong`). */
export const LIVE_PING = 'ping'
export const LIVE_PONG = 'pong'
/** Close code when the session is gone (signed out, expired, archived). Don't reconnect. */
export const LIVE_CLOSE_UNAUTHORIZED = 4401

export const liveEventSchema = z.discriminatedUnion('type', [
  /** First message after connecting. */
  z.object({ type: z.literal('hello') }),
  /** A ticket the receiver could see before or after the change was created or changed. */
  z.object({ type: z.literal('ticket.changed'), id: z.number().int(), key: z.string() }),
  /** Categories, priorities or statuses were saved. */
  z.object({ type: z.literal('config.changed') }),
  /** People were added or changed (Settings → People, sign-in that creates someone). */
  z.object({ type: z.literal('users.changed') }),
])
export type LiveEvent = z.infer<typeof liveEventSchema>

export function parseLiveEvent(raw: string): LiveEvent | null {
  try {
    const parsed = liveEventSchema.safeParse(JSON.parse(raw))
    return parsed.success ? parsed.data : null
  } catch {
    return null
  }
}
